import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class CommentService {
  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COMMENT_UPDATE(
          $id: String!
          $data: CommentInput!
        ) {
          commentUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.commentUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COMMENT_DESTROY($ids: [String!]!) {
          commentDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.commentDestroy;
  }

  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COMMENT_CREATE($data: CommentInput!) {
          commentCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.commentCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COMMENT_IMPORT(
          $data: CommentInput!
          $importHash: String!
        ) {
          commentImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.commentImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query COMMENT_FIND($id: String!) {
          commentFind(id: $id) {
            id
            admin {
              id
            }
            comment
            status
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });

    return response.data.commentFind;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query COMMENT_LIST(
          $filter: CommentFilterInput
          $orderBy: CommentOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          commentList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              admin {
                id
              }
              comment
              status
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.commentList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query COMMENT_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          commentAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.commentAutocomplete;
  }
}
